import { useReactTable, getCoreRowModel } from "@tanstack/react-table";
import Table from "./Table";
import { useColumns } from "./useColumns";
import type { Event } from "../../../../types/Event";

interface Props {
    data: Event[];
    viewBy: string
}

function Content({ data, viewBy }: Props) {
    const columns: any = useColumns(viewBy);

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return (
        <div className="tw-flex-1 tw-min-h-0 " style={{ height: "inherit" }}>
            <Table table={table} viewBy={viewBy} />
        </div>
    );
}

export default Content;

